import { color, spacing } from "@universityofmaryland/web-token-library";
import "../../typography/font-face/index.js";
import "../../typography/campaign.js";
import "../../typography/elements.js";
import { large as large$1 } from "../../typography/sans.js";
import "../../typography/serif.js";
import "../../typography/stats.js";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-text-label";
const { className: _, ...sansLargeStyles } = large$1;
const label = {
  ...sansLargeStyles,
  display: "inline-block",
  position: "relative",
  marginBottom: spacing.sm,
  "&:has(+ input[required]):after, &:has(+ textarea[required]):after": {
    content: "' *'",
    color: color.redDark
  },
  "&[for]": {
    cursor: "pointer"
  }
};
const large = objectWithClassName({
  className: `${classNamePrefix}-large`,
  ...label
});
export {
  label,
  large
};
//# sourceMappingURL=label.js.map
